import { z } from "zod";
import { patientApi } from "./apiClient";

const jwtSchema = z.object({ baseUrl: z.string(), token: z.string() });

export const getCareJwt = async () => {
  const url = `chat/token`;
  return await patientApi.post(url).json(jwtSchema);
};
